<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15FzQyI/tc-custom/9781609452100.jpg?1700880628563" alt="This image is the cover for the book Stories of Jane Gardam"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stories of Jane Gardam
      </h1>
      <p class="bookDescription body article font2">
        <b>“Pure delight . . . One perfect story after another” from the Whitbread Award–winning author of the Old Filth trilogy (<i>The Sunday Telegraph</i>).</b><br/><br/>From the inimitable Jane Gardam, whose Old Filth trilogy cemented her status as one of England’s greatest living novelists, comes a collection of short stories that showcase her subversive wit, gentle humor, and insight into the human condition. Gardam’s versatility is on full display, while her sublime grasp of language and powers of observation remain as provocative as ever.<br/><br/>“A formidable collection that is at once outlandish and entirely convincing . . . It is Gardam’s gift for the ecstatic, for showing us what a place of wonders is the world and the hearts that dwell in it, that endows this collection with a dangerous and formidable energy, richer and more concentrated than any novel. She gives us miracle heaped upon miracle, and insists that they should each one be handled with care.” —<i>The Guardian</i><br/><br/>“Unexpected appearance of figures from the past drive many of these sly, bighearted tales.” —<i>The New York Times</i><br/><br/>“Readers will feel lucky to have so much good writing in one place.” —<i>Publishers Weekly</i> (starred review)<br/><br/>“Gardam’s preference for short stories shows in this extraordinary collection of great writing.” —<i>NewPages Book Reviews</i><br/><br/>“A rich haul from a well of talent.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Gardam
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32dd7662